// Kuest badge: rounded-full px-2 py-0.5 text-xs font-medium; status colours at 15% + full-colour text.
const TONES = {
  green: "bg-yes/15 text-yes",
  amber: "bg-amber-500/15 text-amber-700 dark:text-amber-300",
  red: "bg-no/15 text-no",
  gray: "bg-secondary text-secondary-foreground",
  blue: "bg-chart-1/15 text-link",
};

export default function StatusBadge({ label, tone = "gray" }) {
  return <span className={`inline-flex items-center whitespace-nowrap rounded-md border border-transparent px-2 py-0.5 text-xs font-medium ${TONES[tone] || TONES.gray}`}>{label}</span>;
}
